import { ApiError } from '@lib/api/api-response';

export function isApiError(error: unknown): error is ApiError {
  if (typeof error !== 'object' || error === null) return false;
  const candidate = error as { name?: unknown; status?: unknown };
  return candidate.name === 'ApiError' && typeof candidate.status === 'number';
}
